/*global window: false */
/* app/ui/nav/load */

define(
	'app/ui/nav/nav',[
		'jquery',
		'util/mediaqueries',
		'throttledebounce',
		'pubsub',
		'lazyscroll'
	],

	function ( $, MediaQueries ) {

		"use strict";

		var Nav;
		var $nav;
		var $menu;
		var $header;
		var $body;
		var $window;


		return {

			init: function () {
				Nav = this;
				$nav = $('.js-nav');
				$menu = $('.js-menu');
				$header = $('.js-header');
				$body = $('body');
				$window = $(window);
				this._initEvents();
				this._initMediaqueries();
			},
			_initEvents: function(){
				$window.on('scroll', $.throttle(250, this._fixHeader));
				$menu.on( 'click', this._toggleClick );
			},
			_initAjaxEvents: function(){
				$window.on('scroll', $.throttle(250, this._setNav));
				$('body').on('click', '.js-nav__link', this._processNavClick);
			},
			_initSubscriptions: function(){
				$.subscribe( '/nav/update', this._processUpdateNavEvent );
			},
			_initMediaqueries: function(){
				MediaQueries.register([{
					queries: 'screen and (min-width: 700px)',
					shouldDegrade: false,
					match: function(){
						if( $('.ajax-content').length && window.history.pushState ) {
							Nav._initAjaxEvents();
							Nav._initSubscriptions();
							Nav._setNav();
						}
					}
				}]);
			},
			_toggleClick: function(){
				$nav.toggleClass( 'is-expanded' );
			},
			_processNavClick: function( event ){
				event.preventDefault();
				var $thisNavItem = $(this);
				if( !$thisNavItem.is( '.is-selected' ) ) {
					var id = $thisNavItem.attr('data-link-id');
					Nav._setSelected( $thisNavItem );
					Nav._processContentNavigation( id );
				}
			},
			_processUpdateNavEvent: function( data ){
				var id = data.id;
				var $selectedNavItem = $('[data-link-id="' + id + '"]');
				Nav._setSelected( $selectedNavItem );
			},
			_fixHeader: function(){
				var scrollHeight = $window.scrollTop();
				var headerHeight = $header.height();
				if( scrollHeight > 0 ) {
					$body.css({
						'padding-top': headerHeight + 'px'
					});
					$header.addClass( 'is-fixed' );
					return;
				}
				$body.css({
					'padding-top': ''
				});
				$header.removeClass( 'is-fixed' );
			},
			_setNav: function(){
				var title = '';
				var $pages = $('.js-main');
				$pages.each(function(){
					var $thisContentItem = $(this);
					var scrollPosition = $window.scrollTop();
					var itemPosition = $thisContentItem.offset().top;
					var currentUrl = window.location.pathname;
					if( scrollPosition > itemPosition - 100 && scrollPosition < itemPosition + 100 ) {
						var order = $thisContentItem.attr('data-order');
						var $navItem = $('.js-nav__link').filter(function(){
							return $(this).attr('data-link-order') === order;
						});
						var id = $navItem.attr( 'data-link-id' );
						var url = id === 'homepage' ? '/' : '/' + id;
						if( url !== currentUrl ) {
							Nav._setSelected( $navItem );
							$.publish('/history/push', [{
								url: url,
								id: id
							}]);
							title = url === '/' ? 'Auckland Sea Shuttles' : $.trim($('.' + id ).find('h1').first().text());
							$.publish('/track/pageview', [{
								url: url,
								title: title
							}]);
						}
						return false;
					}
				});
			},
			_processContentNavigation: function( id ){

				var currentUrl = window.location.pathname;
				var url = id === 'homepage' ? '/' : '/' + id;
				if( url !== currentUrl ) {
					$.publish('/history/push', [{
						url: url,
						id: id
					}]);
				}

				if($('.' + id).length) {
					$.publish('/scroller/move', [{
						element: $('.' + id )[0],
						time: 1500,
						easing: 'easeOutExpo'
					}]);
					return;
				}

				$.publish( '/content/get', [{
					id: id,
					url: url,
					isNewContent: url !== currentUrl
				}] );
			},
			_setSelected: function( $thisNavItem ){
				$nav.find('.is-selected').removeClass( 'is-selected' );
				$thisNavItem.addClass( 'is-selected' );
			}
		};

	}
);

